import {
    COUNTRY_LISTING_CF_SUCCESS,
    COUNTRY_LISTING_CF_ERROR,
    COUNTRY_LISTING_CF_START,
    STATE_LISTING_CF_SUCCESS,
    STATE_LISTING_CF_ERROR,
    STATE_LISTING_CF_START,
    CITY_LISTING_CF_SUCCESS,
    CITY_LISTING_CF_ERROR,
    CITY_LISTING_CF_START
} from "Constant";

const initialState = {
    loading: false,
    data: [],
};
export function CountryReducer(
    state = { ...initialState },
    action
) {
    switch (action.type) {
        case COUNTRY_LISTING_CF_START:
            return {
                ...state,
                loading: true,
            };
        case COUNTRY_LISTING_CF_SUCCESS:
            return {
                ...state,
                countryList: action.payload,
                loading: false,
            };
        case COUNTRY_LISTING_CF_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        default:
            return state;
    }
}

export function StateReducer(
    state = { ...initialState },
    action
) {
    switch (action.type) {
        case STATE_LISTING_CF_START:
            return {
                ...state,
                loading: true,
            };
        case STATE_LISTING_CF_SUCCESS:
            return {
                ...state,
                stateList: action.payload,
                loading: false,
            };
        case STATE_LISTING_CF_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        default:
            return state;
    }
}

export function CityReducer(
    state = { ...initialState },
    action
) {
    switch (action.type) {

        case CITY_LISTING_CF_START:
            return {
                ...state,
                loading: true,
            };
        case CITY_LISTING_CF_SUCCESS:
            return {
                ...state,
                cityList: action.payload,
                loading: false,
            };
        case CITY_LISTING_CF_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        default:
            return state;
    }
}
